/**
 * Handle product swatches. Main logic works with product ids.
 * Requirements:
 *    - swatches snippet
 *    - product-group-images snippet
 *    - 'js-swatches="container"' attribute on the wrapping element
 */
const swatches = function () {
  const selectors = {
    wrapper: '[js-swatches="container"]',
    swatchesContainer: '.js-swatches',
    imagesContainer: '.js-product-group-images',
    image: '.js-product-group-image',
    swatch: '.js-swatch',
    titleColor: '.js-title-color',
    dataProductId(id) {
      return id ? `[data-product-id="${id}"]` : '[data-product-id]';
    },
    dataMainProductId(id) {
      return id ? `[data-main-product-id="${id}"]` : '[data-main-product-id]';
    },
  };

  if (
    !$(selectors.swatchesContainer).length ||
    !$(selectors.imagesContainer).length
  ) {
    return;
  }

  /**
   * Change color title
   * @param {jQuery Element} $element
   * @param {String} value
   */
  function changeColorTitle($element, value) {
    if (!$element.length) {
      return;
    }
    const defaultTitle = $element.data('default-title');

    if (!value) {
      $element.text(`(${defaultTitle})`)
      return;
    }

    $element.text(`(${value})`)
  }

  /**
   * Handle swatch hover event
   * @param {Event Object} e
   */
  function handleSwatchHover(e) {
    const $swatch = $(e.target);
    const productId = $swatch.find(selectors.dataProductId()).data('product-id');
    const $wrapper = $swatch.closest(selectors.wrapper);
    const $colorTitle = $wrapper.find(selectors.titleColor);
    const colorTitle = $swatch.find('[data-title]').data('title');
    const mainProductId = $swatch
      .closest(selectors.dataMainProductId)
      .data('main-product-id');

    const $imageContainer = $wrapper.find(
      `${selectors.imagesContainer}${selectors.dataMainProductId(
        mainProductId
      )}`
    );
    const $image = $imageContainer
      .find(`${selectors.dataProductId(productId)}`);

    if (!$image.length) {
      return;
    }

    if (e.type == "mouseenter") {
      $image.removeClass('hidden');
      $imageContainer.addClass('visible');
      changeColorTitle($colorTitle, colorTitle);
      return;
    }

    $image.addClass('hidden');
    $imageContainer.removeClass('visible');
    changeColorTitle($colorTitle);
  }

  getWindow = $(window).width();

  if (getWindow > 1023) {
    $(document).on('mouseenter', selectors.swatch, handleSwatchHover)
    $(document).on('mouseleave', selectors.swatch, handleSwatchHover);
  }

}

swatches();
